import { generatePath, useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { FOLDER_VIEWS_PATH, UPLOADS_VIEWS_PATH } from 'paths'

export const useChangeActiveSchema = () => {
  const history = useHistory()
  const location = useLocation()
  const folderViewsRouteMatch = useRouteMatch<{ folderSlug: string }>(FOLDER_VIEWS_PATH)
  const uploadViewsRouteMatch = useRouteMatch(UPLOADS_VIEWS_PATH)
  const viewsRoutMatch = folderViewsRouteMatch || uploadViewsRouteMatch

  const changeActiveSchema = (id: number) => {
    if (viewsRoutMatch) {
      const pathname = generatePath(viewsRoutMatch.path, { ...viewsRoutMatch.params, views: id })
      history.replace({
        pathname,
        search: location.search,
      })
    } else {
      history.push(`${location.pathname}/views/${id}`)
    }
  }

  return {
    changeActiveSchema,
  }
}
